import {RouteDefinition} from '../../../routes';
import {SoundEditScreen} from './SoundEditScreen';

export const SoundSettingsRoutes: RouteDefinition[] = [
    {
        name: 'Sound',
        routerLink: '/settings/sound',
        component: SoundEditScreen,
    },
];
